import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { env } from '@amfam/environment';
import { CoverageTerm, ICoverage, PolicyCoverage } from '@amfam/policy/models';
import { TermPipe } from '@amfam/policy/pipes';
import { CoverageFilter } from '@amfam/shared/models';
import { CopyService } from '@amfam/shared/utility/shared-services';

@Injectable({ providedIn: 'root' })
export class PolicySharedService {
  constructor(
    private http: HttpClient,
    private copyService: CopyService
  ) {}

  public getFuturePayments(
    payload: { policyNumber: string; submissionId: string },
    plpcEnabled = false
  ) {
    let headers = new HttpHeaders();
    if (env.applicationTitle === 'MyAccount - INT - 01') {
      headers = headers.set('afi-leg', '01');
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.http.post<any>( // TODO: RVPB Add shared type for AddVehicleRateResponse instead of any!
      (plpcEnabled ? env.plpcContextAPI : env.addVehicleContextApi) + 'previewbilling',
      payload,
      { headers: headers }
    );
  }

  getCoveragesForState(isPartner: boolean, state: string): Map<string, CoverageFilter> {
    const coverageFilter = this.copyService.getCopy(
      isPartner
        ? 'policy.changeCoverage.partnerCoverageFilter'
        : 'policy.changeCoverage.coverageFilter'
    );
    const filterMap: Map<string, CoverageFilter> = new Map();
    for (const key in coverageFilter) {
      if (Object.prototype.hasOwnProperty.call(coverageFilter, key)) {
        const filter = coverageFilter[key];
        if (filter && (!filter.states || (filter.states && filter.states.includes(state)))) {
          filterMap.set(key, filter);
        }
      }
    }
    return filterMap;
  }

  getSelectedValue(coverage: ICoverage | PolicyCoverage, isPartner: boolean, state: string) {
    const config: Map<string, CoverageFilter> = this.getCoveragesForState(isPartner, state);
    const summary = config.get(coverage.publicID)?.summary;
    if (summary?.showTerms && coverage.terms.length > 0 && coverage.selected) {
      const termText: string[] = [];
      coverage?.terms.forEach(t => {
        t.options.forEach(op => {
          const coverageTerm = new CoverageTerm();
          coverageTerm.value = String(op.name);
          coverageTerm.description = String(t.name);
          coverageTerm.valueType = summary.valueType;
          const data = new TermPipe().transform(coverageTerm, true);
          if (data) termText.push(`${data.value} ${data.description}`);
        });
      });
      return termText.join(', ');
    } else {
      return coverage.selected || (coverage.terms.length && coverage.terms[0].chosenTermValue)
        ? 'Included'
        : 'Not Included';
    }
  }

  isCheckBox(c: ICoverage): boolean {
    return !c.hasTerms || (c.hasTerms && (c.terms.length < 1 || c.terms[0].options.length === 1));
  }
}
